import { FeatureType, Menu, MenuType } from './menu-item-shared';

export const pricingMenu: Menu = {
  state: 'pricing',
  name: 'menu.price-plans',
  type: MenuType.Static,
  icon: 'payments',
  requiredFeatures: [FeatureType.PricePlans],
};
